import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import FieldPasswordTag from '@/modules/admin/components/FieldPassword/FieldPasswordTag';
import Password from '@/modules/authentication/components/Password';

const FieldPasswordWithLast = ({ onChange }) => {
  const { t } = useTranslation('admin');
  const [isEditing, setIsEditing] = useState();
  const [lastPass, setLastPass] = useState('');
  const [pass, setPass] = useState('');
  
  const handleChangeLastPass = useCallback((event) => {
    const value = event?.target?.value || (typeof event === 'string' ? event : '');
    setLastPass(value);
    onChange && onChange({
      password: pass,
      lastPassword: value
    });
  }, [onChange, pass]);
  
  const handleChangePass = useCallback((event) => {
    const value = event?.target?.value || (typeof event === 'string' ? event : '');
    setPass(value);
    onChange && onChange({
      password: value,
      lastPassword: lastPass
    });
  }, [lastPass, onChange]);
  
  return <div>
    {
      isEditing
        ? <div className="flex flex-col gap-y-4">
          <div>
            <label htmlFor="lastPassword" title="Cambiar contraseña">{t('password.last')}</label>
            <Password value={lastPass} onChange={handleChangeLastPass} generate={false}/>
          </div>
          <div>
            <label htmlFor="password" title="Cambiar contraseña">{t('password.new')}</label>
            <Password value={pass} onChange={handleChangePass}/>
          </div>
        </div>
        : <FieldPasswordTag onClick={() => setIsEditing(true)}/>
    }
  </div>;
  
};

export default memo(FieldPasswordWithLast);

FieldPasswordWithLast.propTypes = {
  form: PropTypes.any,
  lateral: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  size: PropTypes.any,
};

FieldPasswordWithLast.defaultProps = {
  lateral: true
};

export const renderFieldPasswordWithLast = ({ formItemProps, form, field }) => {
  
  const onChange = (value = {}) => {
    const { password, lastPassword } = value || {};
    // eslint-disable-next-line react/prop-types
    form.setFieldsValue({
      password,
      lastPassword,
    });
  };
  
  return (
    <Form.Item {...formItemProps} required={field?.required}>
      <FieldPasswordWithLast {...field?.widgetProps} {...field} onChange={onChange}/>
    </Form.Item>
  );
};

